import React from 'react';
import './Spinner.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
	progress: {
		margin: theme.spacing(2),
		width: '100px !important',
		height: '100px !important',
		color: '#0077ff !important'
	},
}));
const Spinner = () => {
	const spinnerClass = useStyles();
	return (
		<div className="backdrop">
			<div className="textCenter loading">
				<div className="spinnerBorder" role="status">
					<span className="srOnly">
						<CircularProgress className={spinnerClass.progress} />
					</span>
				</div>
			</div>
		</div>
	)
}

export default Spinner;